<style lang="scss" scoped>
.nav_d {
    padding-top: 42px;
    font-size: 30px;
    margin-bottom: 25px;
    display: flex;

}

.nav_d>div {
    margin-right: 68px;
    text-align: center;
    color: #848484;
    font-weight: bold;
}

.nav_d .active {
    color: #000;
}

.center_d {
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.center_d>div {
    margin-bottom: 52px;
    width: calc(100% / 3 - 15px);


}

.container_title {
    margin: 0;
}

.msg {
    margin-top: 12px;

    .msg_L {
        min-width: 40px;
        background-color: #282A2D;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        margin-right: 16px;
        line-height: 1;

        .num {
            font-size: 16px;
            font-weight: bold;
            line-height: 24px;
        }

        .num2 {
            font-size: 16px;
            font-weight: bold;
            line-height: 24px;
            margin: 7px 0
        }

    }

    .border {
        width: 1px;
        height: 10px;
        background: #fff;
        margin: 7px 0
    }

}

.text1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    font-weight: bolder;
    padding-top: 42px;

    font-size: 32px;
    color: #000000;
}

.text2 {
    font-size: 16px;
    margin-top: 26px;

    color: #000000;
    line-height: 18px;
    margin-bottom: 36px;
}


.title1 {
    font-size: 20px;
    color: #000000;
    height: 101px;
    margin-bottom: 12px;
}

.title2 {
    color: #007BC0;
    font-size: 16px;
    margin-top: 26px;
    line-height: 18px;
    margin-bottom: 8px;
}

.title3 {
    font-size: 14px;
    color: #848484;
}

.ellipsis2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.body_center {
    padding-bottom: 119px;
}

.top_icon {
    width: 36px;
    height: auto;
    margin-left: 48px;
}

.input_select_d {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 1);
    font-size: 16px;
    margin-bottom: 40px;
    box-sizing: border-box;

    .li {
        color: rgba(0, 0, 0, 1);
        // padding: 0 16px;
        margin-right: 95px;
    }

    .active {
        color: #007BC0;
        border-bottom: 2px solid #007BC0;
        box-sizing: border-box;
        z-index: 10;
    }
}

/* 移动端 */
@media (max-width: 1200px) and (min-width: 300px) {
    .input_select_d {
        font-size: 12px;
        margin-bottom: 11px;

        .li {
            margin-right: 32px;
        }
    }

    .top_icon {
        width: 24px;
        height: auto;
        margin-left: 21px;
    }

    .text1 {
        padding-top: 20px;
        font-size: 18px;
        line-height: 22px;
    }

    .text2 {
        font-size: 14px;
        margin-top: 8px;
        line-height: 18px;
        margin-bottom: 16px;
    }

    .body_center {
        padding-bottom: 0px;
    }

    .nav_d {
        padding-top: 16px;
        font-size: 18px;
        margin-bottom: 11px;
    }

    .nav_d>div {
        margin-right: 34px;
    }

    .center_d {
        box-sizing: border-box;
        padding: 11px 11px 0 11px;
    }

    .center_d>div {
        background: #fff;
        margin-bottom: 52px;
        width: calc(100% - 4.5px);
        margin-bottom: 24px;
        border-radius: 4px;

    }

    .title1 {
        height: 60px;
        font-size: 15px;
        line-height: 18px;
        color: #000000;
        margin-top: 11px;
        margin-bottom: 6px;
        font-weight: bold;
    }

    .title2 {
        width: 108px;
        height: 32px;
        font-size: 14px;
    }

    .ellipsis2 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 40px;
    }

}

@media (max-width: 1200px) and (min-width: 750px) {
    .center_d>div {
        width: calc(50% - 4.5px);

    }
}
</style>
<template>
    <div class="page_d">

        <div class="container">
            <!-- <div class="nav_d row12">
                <div :class="nav == 0 ? 'active' : ''" @click="setNav(0)"><span class="nav_li">All</span></div>
                <div :class="nav == 1 ? 'active' : ''" @click="setNav(1)"><span class="nav_li">News</span></div>
                <div :class="nav == 2 ? 'active' : ''" @click="setNav(2)"><span class="nav_li">Promotion</span></div>
            </div> -->
            <div class="text1">
                <div class="flex1 container_title" style="width: 70%;">{{ client_info && client_info.detailsTypeOf ==
                    'BDC' ? $t("message.BDCtitle") : listtitle[0]?.title }}</div>

               
                <img src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/WhatsOn/facebook.png"
                    alt="img" class="top_icon pointer" @click="goweb(1)" >
                <img src="https://azportalstorageblob.blob.core.windows.net/azportal-uat/H5_img/WhatsOn/instagram.png"
                    alt="img" class="top_icon pointer" @click="goweb(2)" v-if="countryNameAbbreviation != 'VN' && client_info?.detailsTypeOf !=
                        'BDC'">

            </div>
            <div class="text2">{{ client_info && client_info.detailsTypeOf == 'BDC' ? $t("message.BDCcenter") :
                listtitle[0]?.content || $t("message.ThoEvontTeasorGroupOllors") }}</div>
            <div class="input_select_d" v-if="client_info && client_info.detailsTypeOf == 'BDC'">
                <div class="li pointer" :class="nav == 0 ? 'active ' : ''" @click="nav = 0, getpage(1)">{{
                    $t('message.ALL') }}
                </div>
                <div class="li pointer" :class="nav == 1 ? 'active ' : ''" @click="nav = 1, getpage(1)">{{
                    $t('message.News')
                    }}</div>
                <div class="li pointer" :class="nav == 2 ? 'active ' : ''" @click="nav = 2, getpage(1)">{{
                    $t('message.Promotion') }}</div>
                <div class="li pointer" :class="nav == 3 ? 'active ' : ''" @click="nav = 3, getpage(1)">{{
                    $t('message.E_Magizines') }}</div>
            </div>
        </div>

        <div class="body_center">
            <div class="container ydShow_padding0">
                <div class="center_d row12 d-flex">
                    <div class="pointer" v-for="item in list" :key="item.questionInformationId" :index="index"
                        @click="goMsg(item, index)">
                        <el-image class="pcShow" :src="item.thumbnailUrl" style="width: 100%; height: 217px;"
                            fit="cover"></el-image>
                        <img class="ydShow" :src="item.thumbnailUrl" alt="img">
                        <div class="msg d-flex">
                            <div class="msg_L" v-if="item.classify == 1 || item.classify == 3">
                                <div>{{ item.createDate | formatDate_en_month }}</div>
                                <div class="num2">{{ item.createDate | formatDate_en_day }}</div>
                                <div>{{ item.createDate | formatDate_en_year }}</div>
                            </div>
                            <div class="msg_L" v-if="item.classify == 2">
                                <div>{{ item.activityStartTime | formatDate_en_month }}</div>
                                <div class="num">{{ item.activityStartTime | formatDate_en_day }}</div>
                                <div class="border"></div>
                                <div>{{ item.activityEndTime | formatDate_en_month }}</div>
                                <div class="num">{{ item.activityEndTime | formatDate_en_day }}</div>
                            </div>
                            <div class="msg_R">
                                <div class="title1 ellipsis3">{{ item.title }}</div>
                                <div class="title3">
                                    <!-- <a :href="item.fileUrl" v-if="item.magizinesType == 1">{{ $t("message.FileFormat") + ': PDF' }}</a> -->
                                    <div v-if="item.magizinesType == 1">{{ $t("message.FileFormat") + ': PDF' }}</div>
                                    <div v-else style="opacity: 0;">{{ $t("message.FileFormat") + ': PDF' }}</div>

                                </div>
                                <div class="title2 d-flex align-items-center">{{ $t("message.LearnMore") }}</div>
                            </div>
                        </div>

                    </div>
                    <div class="pcShow" v-if="list.length % 3 == 2"></div>

                </div>
            </div>
        </div>
        <div class="body_center">
            <div class="container ydShow_padding0">
                <div class="block pagination_d" v-if="recordsTotal">
                    <el-pagination small="true" @current-change="handleCurrentChange" :current-page.sync="page"
                        :page-size="pageSize" layout="prev, pager, next, jumper" :total="recordsTotal">
                    </el-pagination>
                </div>

                <div v-if="recordsTotal == 0" class="none_hint">{{ client_info && client_info.detailsTypeOf ==
                    'BDC' ? $t("message.NoDataAvailable2") : $t("message.NoDataAvailable") }}</div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from "../main"
export default {

    components: {
    },
    name: "WhatsOn",
    props: {
        msg: String,
    },
    data() {
        return {
            nav: 0,
            listtitle: '',
            list: [],
            page: 1,
            pageSize: 6,
            recordsTotal: '',
            country: '',
            countryNameAbbreviation: '',
            client_info: '',
        }
    },
    created() {
        this.getpage()
        this.gettitle()
        if (localStorage.getItem("country")) {
            this.countryNameAbbreviation = JSON.parse(localStorage.getItem("country")).countryNameAbbreviation
            console.log('this.countryNameAbbreviation========',this.countryNameAbbreviation)
        }
        if (localStorage.getItem("client_info")) {
            this.client_info = JSON.parse(localStorage.getItem("client_info"))
            console.log('this.client_info.clientType_________', this.client_info.clientType)
            console.log('this.client_info.detailsTypeOf_________', this.client_info.detailsTypeOf)
        }

    },
    methods: {
        // 强制在浏览器中打开PDF的方法
        openPdfInNewWindow(pdfUrl) {
            // 为不同来源的PDF提供不同的查看方案
            var newWindow = window.open('', '_blank');

            // 如果是Azure Blob或其他可能强制下载的链接，使用Google Docs Viewer
            if (pdfUrl.includes('blob.core.windows.net') ||
                pdfUrl.includes('amazonaws.com') ||
                pdfUrl.includes('storage.googleapis.com')) {
                var viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`;
                newWindow.location.href = viewerUrl;
            } else {
                // 对于其他链接，使用iframe
                newWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>PDF Viewer</title>
                        <meta charset="UTF-8">
                        <style>
                            body { margin: 0; padding: 0; overflow: hidden; }
                            iframe { width: 100vw; height: 100vh; border: none; }
                            .loading { 
                                position: absolute; top: 50%; left: 50%; 
                                transform: translate(-50%, -50%); 
                                font-family: Arial, sans-serif; 
                            }
                        </style>
                    </head>
                    <body>
                        <div class="loading">正在加载PDF...</div>
                        <iframe src="${pdfUrl}" type="application/pdf" onload="document.querySelector('.loading').style.display='none'"></iframe>
                    </body>
                    </html>
                `);
                newWindow.document.close();
            }
        },
        goweb(type) {
            var countryNameAbbreviation = ''
            var url = ''
            if (localStorage.getItem("country")) {
                countryNameAbbreviation = JSON.parse(localStorage.getItem("country")).countryNameAbbreviation
            }
            console.log('countryNameAbbreviation====', countryNameAbbreviation, '________type===', type)
            if (type == 1) {
                // 【Facebook】
                if (this.client_info && this.client_info?.detailsTypeOf == 'BDC') {
                    switch (countryNameAbbreviation) {
                        case 'SG':
                            url = 'https://www.facebook.com/groups/512636673208321/'
                            break;
                        case 'MY':
                            url = 'https://www.facebook.com/groups/290309176105160/'
                            break;
                        case 'PH':
                            url = 'https://www.facebook.com/groups/957917278329875/'
                            break;
                        case 'TH':
                            url = 'https://www.facebook.com/groups/193133516032342/'
                            break;
                        case 'ID':
                            url = 'https://www.facebook.com/groups/342627021247238/'
                            break;
                        case 'VN':
                            url = 'https://www.facebook.com/groups/949041250200222/'
                            break;
                        default:
                    }
                } else {
                    switch (countryNameAbbreviation) {
                        case 'SG':
                            url = 'https://www.facebook.com/boschautopartssg'
                            break;
                        case 'MY':
                            url = 'https://www.facebook.com/BoschAA.MY/'
                            break;
                        case 'PH':
                            url = 'https://www.facebook.com/BoschAutopartsPH/'
                            break;
                        case 'TH':
                            url = 'https://www.facebook.com/BoschAA.TH/'
                            break;
                        case 'ID':
                            url = 'https://www.facebook.com/boschautopartsid/'
                            break;
                        case 'VN':
                            url = 'https://www.facebook.com/BoschAA.VN'
                            break;
                        default:
                    }
                }
                // SG: www.facebook.com/boschautopartssg
                // MY: www.facebook.com/BoschAA.MY/
                // PH: www.facebook.com/BoschAutopartsPH/
                // TH: www.facebook.com/BoschAA.TH/
                // ID: www.facebook.com/boschautopartsid/
                // VN: www.facebook.com/BoschAA.VN
            } else if (type == 2) {
                if (this.client_info && this.client_info?.detailsTypeOf == 'BDC') {
                    switch (countryNameAbbreviation) {
                        case 'SG':
                            url = 'https://www.facebook.com/groups/512636673208321/'
                            break;
                        case 'MY':
                            url = 'https://www.facebook.com/groups/290309176105160/'
                            break;
                        case 'PH':
                            url = 'https://www.facebook.com/groups/957917278329875/'
                            break;
                        case 'TH':
                            url = 'https://www.facebook.com/groups/193133516032342/'
                            break;
                        case 'ID':
                            url = 'https://www.facebook.com/groups/342627021247238/'
                            break;
                        case 'VN':
                            url = 'https://www.facebook.com/groups/949041250200222/'
                            break;
                        default:
                    }
                } else {
                    switch (countryNameAbbreviation) {
                        case 'SG':
                            url = 'https://www.instagram.com/boschautoparts_sg/'
                            break;
                        case 'MY':
                            url = 'https://www.instagram.com/boschautoparts_my/'
                            break;
                        case 'PH':
                            url = 'https://www.instagram.com/boschautoparts_ph/'
                            break;
                        case 'TH':
                            url = 'https://www.instagram.com/boschautoparts_th/'
                            break;
                        case 'ID':
                            url = 'https://www.instagram.com/boschautomotiveid/'
                            break;
                        case 'VN':
                            url = ''
                            break;
                        default:
                    }
                }

                // 【Instagram】
                // SG: www.instagram.com/boschautoparts_sg/
                // MY: www.instagram.com/boschautoparts_my/
                // TH: www.instagram.com/boschautoparts_th/
                // PH: www.instagram.com/boschautoparts_ph/
                // ID: www.instagram.com/boschautomotiveid/
            }
            console.log('url==', url)
            if (url) {
                window.open(url, "_blank");
            }


        },
        handleCurrentChange(e) {
            console.log('handleCurrentChange==', e)
            this.page = e
            this.getpage()
        },
        setNav(num) {
            this.nav = num
            this.page = 1
            this.getpage()
        },
        goMsg(item, index) {
            console.log('item===', item)
            // var that = this
            // const href = that.$router.resolve({
            //     path: `/article`,
            //     query: {
            //         questionInformationId: item.questionInformationId
            //     }
            // });
            // window.open(href, "_blank");

            // var routeData = {
            //     name: 'article',
            //     query: { Id: item.questionInformationId }
            // }
            // const routeUrl = this.$router.resolve(routeData).href;
            // window.open(routeUrl, '_blank');
            if (EventBus) { //埋点
                var obj = {}
                obj.name = 'wsp_whatson_click'
                obj.params = {
                    Typy: 'Whats on page usage',
                    Name: "what's on news click",
                    page_num: index,
                    article_title: item.title,
                    article_id: item.questionInformationId,
                }
                EventBus.$emit('google-analytics', obj);
            }

            var that = this

            if (item.magizinesType == 1) {
                var url = item.fileUrl
                console.log('PDF URL===', url)
                window.open(url, "_blank");
                return false
                // 针对Azure Blob Storage的PDF，使用Google Docs Viewer确保在线查看
                if (url.includes('azportalstorageblob.blob.core.windows.net') ||
                    url.includes('blob.core.windows.net')) {
                    // 使用Google Docs Viewer强制在线查看Azure Blob PDF
                    var viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`
                    window.open(viewerUrl, '_blank');
                } else {
                    // 对于其他PDF链接，尝试iframe方法
                    this.openPdfInNewWindow(url);
                }
                // that.$router.push({
                //     name: "pdf",
                //     // query: { url: item.fileUrl }
                //     query: { url: 'http://example.com/path/to/file.pdf' }

                // }, () => { });
                // // 通过a标签来实现下载
                // var href = item.fileUrl
                // var a = document.createElement("a") //创建一个<a></a>标签
                // a.href = href //给a标签的href属性值加上地址，注意，这里是绝对路径，不用    加 点.
                // a.download =  item.title+'.pdf'//设置下载文件文件名，这里加上.docx指定文件类型，pdf文件就指定.pdf即可
                // a.style.display = "none" //隐藏a标签
                // document.body.append("a") //将a标签追加到document.body中
                // a.click() //模拟点击a标签，会触发a标签的href的读取，浏览器就会自动下载了
                // a.remove() // 删除a标签（一次性的）


            } else {
                that.$router.push({
                    name: "article",
                    query: { Id: item.questionInformationId }
                }, () => { });
            }


        },
        getpage() {
            var that = this
            that.$flyNo.request({
                method: 'POST',
                url: that.httpUrl.questionInformationpage,
                body: {
                    technicalEncyclopediaTypeId: that.nav.technicalEncyclopediaTypeId,
                    page: that.page,
                    pageSize: that.pageSize,
                    classify: that.nav,
                    isIdentity: 1,
                }
            }).then(res => {
                if (!res) return false
                console.log('--------------——', that.httpUrl.questionInformationpage, '_res==', res)
                that.list = res.resultData.pageInfo.rows
                that.recordsTotal = res.resultData.pageInfo.pageProps.totalCounts || 0
            })

        },
        gettitle() {
            var that = this
            that.$flyNo.request({
                method: 'POST',
                url: that.httpUrl.questionInformationpage,
                body: {
                    technicalEncyclopediaTypeId: that.nav.technicalEncyclopediaTypeId,
                    page: that.page,
                    pageSize: that.pageSize,
                    classify: 10,
                    isIdentity: 1
                }
            }).then(res => {
                if (!res) return false
                console.log('--------------——', that.httpUrl.questionInformationpage, '_res==', res)
                that.listtitle = res.resultData.pageInfo.rows
            })

        }
    }
}
</script>
